import { Container } from "@mui/material";
import { useContext, useEffect } from "react";
import SEO from "../components/SEO";
import CONFIG from "../config";
import { SiteStateContext } from "../contexts/SiteStateContext";
import gaEvents from "../util/gaEvent";
import { fixSiteState } from "../util/site_state";

export function ServicePage() {
    const { setSiteState } = useContext(SiteStateContext);

    useEffect(() => {
        if (setSiteState) {
            setSiteState(fixSiteState({ title: "Service Reporting", navHighlight: "/service", hideFooter: true }));
        }
    }, [setSiteState]);

    gaEvents.misc.service_redirect();

    window.location.href = CONFIG.service_reporting_url;

    return (
        <Container sx={{ mt: "60px", textAlign: "center" }}>
            <SEO 
                title="Service Reporting - River Hawk Chapter"
                description="Report your service hours for River Hawk Chapter activities and help track our community impact."
                keywords="Service Hours, Community Service, Scout Service, OA Service Projects, Volunteer Hours"
            />
            Redirecting...
        </Container>
    );
}
